import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
//import PureNavigation from '@tsnpm/uikit/dist/UI/Organisms/Navigation';
import PureNavigation from '@ts/components/Navigation';

import selectors from '@ts/core/selectors';
import actions from '@ts/core/actions';
import { Link as PrefetchLink } from '@ts/components/PrefetchRoute';
import { AnalyticsInstance } from '@ts/utils/analytics';

const Navigation = () => {
    const navigationIsOpen = useSelector(selectors.navigation.makeSelectNavigationUsOpen());
    const cartItems = useSelector(selectors.cart.makeSelectItems());
    const countCartItems = cartItems.length;
    const dispatch = useDispatch();
    const closeNavigation = () => {
        dispatch(actions.navigation.closeNavigation());
        AnalyticsInstance.closeNavigation();
    };
    const openTalkToUs = () => {
        dispatch(actions.talkToUs.openTalkToUs());
        document.querySelector('body').classList.add('body--ovh--important');
    };
    return (
        <PureNavigation
            navigationIsOpen={navigationIsOpen}
            closeNavigation={closeNavigation}
            countCartItems={countCartItems}
            PrefetchLink={PrefetchLink}
            openTalkToUs={openTalkToUs}
        />
    );
};
export default Navigation;
